/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2014, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define(['../../lib/@waca/core-client/js/core-client/ui/core/View', 'jquery', '../../app/ui/Splitter'], function(View, $) {
	return class SplitPaneView extends View {
		constructor(...args) {
			super(...args);
		}

		init (...args) {
			super.init(...args);
			this.$bottom = null;
			this.$top = null;
			this.$content = null;
			this.splitter = null;

			const options = args[0];

			this._splitterItems = options.splitterItems || [];
			this.handlers = options.handlers;
			this.services = options.services;
			this.dashboard = options.dashboardApi;
			this.glassContext = options.services.biGlass.glassContext;
		}

		render (...args) {
			super.render(...args);

			var content = {};
			if (this.glassContext.appController.currentAppView.content) {
				content = this.glassContext.appController.currentAppView.content;
			}
			this.splitter = this.$el.splitter({
				items: this._splitterItems,
				panel: this.getBottomBarNode(),
				content: content,
				handlers: {
					getParentSize: this.handlers.getParentSize
				}
			}).data('splitter');

			return Promise.resolve();
		}

		getBottomBarNode () {
			if (this.$bottom === null) {
				var $bottomPane = $('.bottomPane', this.el);
				if ($bottomPane.length === 0) {
					$bottomPane = $('<div class="bottomPane"></div>').appendTo(this.el);
				}
				this.$bottom = $bottomPane;
			}
			return this.$bottom;
		}

		getContentNode () {
			if (this.$content === null) {
				var $contentNode = this.$('.pageViewContent', this.el);
				if ($contentNode.length === 0) {
					$contentNode = $('<div class="pageViewContent"></div>').prependTo(this.el);
				}
				this.$content = $contentNode;
			}
			return this.$content;
		}

		close() {
			this.splitter.close();
		}

		open() {
			this.splitter.open();
		}

		getSplitter() {
			return this.splitter;
		}

		showHandle(handle) {
			this.splitter.showHandle(handle);
		}

		hideHandle(handle) {
			this.splitter.hideHandle(handle);
		}

		onContainerReady() {
			var promises = [];
			this._splitterItems.forEach(function (item) {
				if (item.view.onContainerReady && typeof item.view.onContainerReady === 'function') {
					promises.push(item.view.onContainerReady());
				}
			}, this);
			return Promise.all(promises);
		}

		slideSplitterToMinSize() {
			if (this.splitter.isOpen()) {
				this._splitterWasOpen = true;
				this.splitter.setPaneSize(120);
			}
		}

		remove(...args) {
			this.$el.destroySplitter();
			this.splitter = null;
			this.$bottom = null;
			this.$top = null;
			this.$content = null;
			this._splitterItems = null;
			this.handlers = null;
			this.services = null;
			this.glassContext = null;
			super.remove(...args);
		}
	};
});
